import { HttpInterceptorFn } from '@angular/common/http';
import { environment } from '@environments/environment';

export const tokenInterceptor: HttpInterceptorFn = (req, next) => {
  //url is api/paymentfile
  if (req.url.includes('api/paymentfile'))  {
    const newReq = req.clone({
    headers: req.headers.append('Authorization', `Bearer ${localStorage?.getItem(environment.token)}`)                        
  });
  if(req.url.includes('login') || req.url.includes('reset-password') || req.url.includes('forgot-password')){
    newReq.headers.delete('Authorization');   
  }
    return next(newReq);
  }

  
  const newReq = req.clone({
    headers: req.headers.append('Content-Type', 'application/json')
                        .append('Authorization', `Bearer ${localStorage?.getItem(environment.token)}`)                        
  });
  if(req.url.includes('login') || req.url.includes('reset-password') || req.url.includes('forgot-password')){
    newReq.headers.delete('Authorization');   
  }
  return next(newReq)
};
